<app-card>
  <div class="row justify-content-center">
    <div class="col-md-3 md-3">
      <h2 *ngIf="application.fundingBucket !== 'BURSARY'" class="text-center mt-3 mb-0">Bursary Offer</h2>
      <h2 *ngIf="application.fundingBucket !== 'LOAN'" class="text-center mt-3 mb-0">Loan Offer</h2>
    </div>

    <form (ngSubmit)="onSubmit()" #acceptOfferForm="ngForm" class="px-5 needs-validation">
       <div class="row md-3">
         <p class="text-center" style="font-size: medium;" *ngIf="application.fundingBucket === 'LOAN'">Dear applicant based on our evaluation of your household income, 
            you qualify for a {{application?.fundingBucket=='LOAN'? 'bursary':'loan'}}
            as your household income is below R350 000.<br/> Please provide a response of either accepting or
             rejecting the offer to apply for a {{application?.fundingBucket=='LOAN'? 'bursary':'loan'}}.
        </p>
         <p class="text-center" style="font-size: medium;" *ngIf="application.fundingBucket === 'BURSARY'">Dear applicant based on our evaluation of your household income, 
            you qualify for a {{application?.fundingBucket=='BURSARY'? 'loan':'bursary'}}
            as your household income is greater than R350 000 and less than R600 000.<br/> Please provide a response of either accepting or
             rejecting the offer to apply for a {{application?.fundingBucket=='BURSARY'? 'loan':'bursary'}}.
        </p>
       </div>
       <div class="row md-3" style="font-size: medium;">
        <div class="form-group text-center mb-5 text-start">
            <div class="checkbox checkbox-fill d-inline">
            <input type="checkbox" name="checkbox-fill-2" id="checkbox-fill-2"  required [(ngModel)]="checked" name="agree"
                     required>
            <label for="checkbox-fill-2" class="cr">I accept the {{application?.fundingBucket=='BURSARY'? 'Loan':'Bursary'}} offer.</label>
    
            <div *ngIf="submitted && !checked" class="invalid-feedback d-block">
                Please agree to accept the offer
            </div>
            </div>
        </div>
        </div>
        <div class="row mb-3">
        <div class="col-md-6">
          <div class="d-grid gap-2">
            <button class="btn btn-outline-dark btn-lg mb-3" type="button" (click)="closeModal()">Decline Offer</button>
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-grid gap-2">
            <button class="btn btn-primary btn-lg mb-3" type="submit" [disabled]="!checked" >Confirm Offer Acceptance</button>
          </div>
        </div>
      </div>


     
    </form>

  </div>
</app-card>


